/**
 * "Nästa kort": the next few cards of the mixed review, from the queue already fetched (pedagogy
 * spec §6.3.4 S7 ④). Only the moment and the kind of each card: a preview of the front or back
 * would defeat the typed recall.
 */
import { useId } from "react";
import { useT } from "@client/i18n";
import { PanelBadges } from "./CardBadges";
import type { SessionCard } from "./session";

export function QueuePanel({ cards }: { cards: readonly SessionCard[] }) {
  const t = useT();
  const headingId = useId();
  if (cards.length === 0) return null;
  return (
    <section aria-labelledby={headingId} className="mt-6">
      <h2 id={headingId} className="mb-2 text-sm font-medium text-ink-700 dark:text-ink-200">
        {t("flashcards.review.queue.title")}
      </h2>
      <ol className="space-y-1.5">
        {cards.map((card) => (
          <li key={card.id}>
            <PanelBadges card={card} />
          </li>
        ))}
      </ol>
    </section>
  );
}
